// Sized for the widest control state - Working's pill (spinner + text) plus its separate stop
// button, ~130px measured live - with a little breathing room for translated text running longer
// than the English default. Not the pill's full original 188px, which left a visible dead gap
// before the next column. Shared so the row cell and its header cell (and, on task-table-v3, the
// table's own width budget) can't drift out of sync with each other.
export const NOVA_INVOCATION_COLUMN_WIDTH = 150;
